module.exports = __webpack_public_path__ + "img/4.f0e8ce95.png";